import React from 'react';
import { InCartBlock } from '../../common/products/productBlock';
const CartItems = ({ products, handleDelete, changeFun }) => (
  <div className="cart_items">
    <ProductList
      products={products}
      handleDelete={handleDelete}
      changeFun={changeFun}
    />
  </div>
);

const ProductList = ({ products, handleDelete, changeFun }) => (
  <div className="products_list">
    {products.map((item) => {
      return (
        <InCartBlock
          key={item.id}
          product={item}
          handleDelete={handleDelete}
          changeFun={changeFun}
        />
      );
    })}
  </div>
);

export default CartItems;
